// extracted by mini-css-extract-plugin
module.exports = {"title":"_timeout_title_2YA_q"};